export default "precision mediump float;\n\nvoid main() {\n    gl_FragColor = vec4(0.15, 0.64, 0.23, 1.0);\n}\n"